/**
 * Created by Marcus Zhao on 11/22/2022.
 * Description:
 * DuplicateEvent Service
 * ------ maintenance history ------
 */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DuplicateEventService {

    dialogOpen$: Subject<any> = new Subject<any>();
}
